"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.popoverProps = exports.NPopover = void 0;
var Popover_1 = require("./src/Popover");
Object.defineProperty(exports, "NPopover", { enumerable: true, get: function () { return __importDefault(Popover_1).default; } });
Object.defineProperty(exports, "popoverProps", { enumerable: true, get: function () { return Popover_1.popoverProps; } });
